import {
  React,
  Component,
  axios,
  routes
} from 'imports/CommonImports';

import {
  AlertDialogWithComments,
  AlertDialog,
  LoadingDialog
} from 'imports/DesignImports';

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
  }
}
class ForgotPassword extends Component {
  state = {
    emailDialog: false,
    loadingDialog: false,
    alertDialog: false,
    alertMessage: '',
    alertTitle: '',
    email: ''
  }
  render() {
    return (
      <div style={{...styles.container, ...this.props.style}}>
        <div className='p2' style={{cursor: 'pointer'}} onClick={() => this.setState({emailDialog: true})}> Olvidé mi contraseña </div>
        {this.state.emailDialog ?
        <AlertDialogWithComments
          message='Ingresa tu email para recuperar tu cuenta'
          mandatoryComment={true}
          handleCommentChange={this.handleChange}
          email={true}
          cancel={() => this.setState({emailDialog: false})}
          confirm={this.sendForgetPassword}/>
        : null
        }
        { this.state.loadingDialog ? <LoadingDialog message="Estamos enviando los datos, espera un momento" /> : null }
        { this.state.alertDialog ?
          <AlertDialog
            title={this.state.alertTitle}
            message={this.state.alertMessage}
            acceptLabel='Aceptar'
            cancelLabel=''
            confirm={() => this.setState({alertDialog: false})}
            cancel={() => this.setState({alertDialog: false})}/> :
            null }
      </div>
    );
  }

  sendForgetPassword = () => {
    this.setState({loadingDialog: true, emailDialog: false})
    var connection = axios.create({
      baseURL: routes.host,
    });
    connection.put(routes.resetPassword, {email:this.state.email})
    .then((response) => {
      this.setState({
        currentStage: response.data,
        loadingDialog: false,
        alertDialog: true,
        alertTitle: '¡Solicitud recibida!',
        alertMessage: 'Hemos recibido tu solicitud, te llegará un correo electrónico con instrucciones para recuperar tu contraseña',
      })
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        loadingDialog: false,
        alertDialog: true,
        alertTitle: '¡Error!',
        alertMessage: 'Hubo problemas al recuperar tus datos. Asegúrate de que estas ingresando el email correcto',
      });
    });
  }

  handleChange = (event) => {
    this.setState({email: event.target.value});
  }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/common/ForgotPassword.js